module.exports = __webpack_public_path__ + "static/media/enquiryImg.abaf590a.jpg";